import React, { useEffect, useState } from "react";
import ModalSkeleton from "components/Modals/ModalSkeleton";
import CustomButton from "components/common/Enhansment/Button/CustomButton";
import DateRangeWithRegister from "components/common/DateRangePicker/DateRangePickerWithRegister";
import { apiPostRequest } from "helpers/Requests";
import { toast } from "react-toastify";
import { getUrlRole } from "Utils/utils";

const SetExpiryDateModal = (props) => {
  const {
    open,
    setOpen,
    isUserGracePeriodOver,
    handleClose,
    uuid,
    refreshFormList,
    participantId,
    currentExpiryDate,
    role,
  } = props;

  const [expiryDate, setExpiryDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [request, setRequest] = useState({
    isRequested: false,
    isSuccess: false,
    isFailed: false,
  });

  useEffect(() => {
    if (open && currentExpiryDate) {
      const parsedDate = new Date(currentExpiryDate);
      const localDate = parsedDate.toLocaleDateString("en-CA"); 
      setExpiryDate(localDate);
    } else if (open) {
      setExpiryDate("");
    }
  }, [open, currentExpiryDate]);

  const handleSave = async () => {
    if (!expiryDate) {
      toast.error("Please select an expiry date.");
      return;
    }

    let apiUrl = "";
    if (role === "hrm") {
      apiUrl = `${getUrlRole()}/employee/submitted-forms/update-expiry`;
    } else if (role === "sil") {
      apiUrl = `sil/home/form/expiry-update`;
    } else {
      apiUrl = `${getUrlRole()}/participant/submitted-forms/update-expiry`;
    }

    const payload = {
      form_id: uuid,
      expiry_date: expiryDate,
    };

    setRequest({ isRequested: true, isSuccess: false, isFailed: false });

    try {
      const response = await apiPostRequest(apiUrl, payload);

      if (response?.status === 200 || response?.status === 201) {
        toast.success("Expiry date updated successfully!");
        refreshFormList();
        setOpen(false);
      } else {
        toast.error(response?.data?.message || "Failed to update expiry date.");
      }
    } catch (error) {
      console.error("Update expiry error:", error);
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong while updating expiry date."
      );
    } finally {
      setLoading(false);
    }
  };

  const modalFooter = () => (
    <>
      <CustomButton
        showLoading={request.isRequested}
        isDisabled={request.isRequested || isUserGracePeriodOver}
        label='Yes, set Expiry Date'
        clickHandler={handleSave}
      />
      <CustomButton
        label='No, cancel changes'
        clickHandler={handleClose}
        variant='danger'
      />
    </>
  );

  return (
    <ModalSkeleton
      modalFooter={modalFooter()}
      isOpen={open}
      closeModal={() => setOpen(false)}
      cssClass="w-[35%] !overflow-visible"
      title='Set Expiry Date'
    >
      <div className='p-4 space-y-4'>
        <input
          type='text'
          style={{
            position: "absolute",
            opacity: 0,
            height: 0,
            width: 0,
            pointerEvents: "none",
          }}
          autoFocus
        />

        <label className='block text-sm font-medium text-gray-700'>
          Select an Expiry date for completed form:
        </label>

        <DateRangeWithRegister
          isSingleDate
          placeholder='Select Expiry Date'
          showCalendarIcon
          field={{
            value: expiryDate,
            onChange: (date) => {
              setExpiryDate(date);
            },
          }}
          fieldState={{
            error: expiryDate ? null : { message: "Please select a date" },
          }}
        />

        <div style={{ height: "100px" }} />

      </div>
    </ModalSkeleton>
  );
};

export default SetExpiryDateModal;
